import { ObjectPathFieldGroup } from '@features/onboarding/utils/pathResolver';

export const MEDICAL_FIELD_GROUPS: ObjectPathFieldGroup[] = [
  {
    title: "General Info",
    items: [
      {
        label: "Plan Name",
        path: "name",
      },
      {
        label: "Plan Type",
        path: "type",
      },
    ],
  },
  {
    title: "Basic Plan Costs",
    items: [
      {
        label: "Individual Deductible (In-Network)",
        path: "details.coverage.Individual Deductible (In-Network)",
      },
      {
        label: "Family Deductible (In-Network)",
        path: "details.coverage.Family Deductible (In-Network)",
      },
      {
        label: "Individual Deductible (Out-of-Network)",
        path: "details.coverage.Individual Deductible (Out-of-Network)",
      },
      {
        label: "Family Deductible (Out-of-Network)",
        path: "details.coverage.Family Deductible (Out-of-Network)",
      },
      {
        label: "In-Network Coinsurance % (Plan pays/You pay)",
        path: "details.coverage.In-Network Coinsurance % (Plan pays/You pay)",
      },
      {
        label: "Out-of-Network Coinsurance % (Plan pays/You pay)",
        path: "details.coverage.Out-of-Network Coinsurance % (Plan pays/You pay)",
      },
      {
        label: "Individual Max Out-of-Pocket (In-Network)",
        path: "details.coverage.Individual Max Out-of-Pocket (In-Network)",
      },
      {
        label: "Individual Max Out-of-Pocket (Out-of-Network)",
        path: "details.coverage.Individual Max Out-of-Pocket (Out-of-Network)",
      },
      {
        label: "Family Max Out-of-Pocket (In-Network)",
        path: "details.coverage.Family Max Out-of-Pocket (In-Network)",
      },
      {
        label: "Family Max Out-of-Pocket (Out-of-Network)",
        path: "details.coverage.Family Max Out-of-Pocket (Out-of-Network)",
      },
    ],
  },
  {
    title: "Doctor Visits",
    items: [
      {
        label: "Primary Care Visit (In-Network)",
        path: "details.coverage.Primary Care Visit (In-Network)",
      },
      {
        label: "Primary Care Visit (Out-of-Network)",
        path: "details.coverage.Primary Care Visit (Out-of-Network)",
      },
      {
        label: "Specialist Visit (In-Network)",
        path: "details.coverage.Specialist Visit (In-Network)",
      },
      {
        label: "Specialist Visit (Out-of-Network)",
        path: "details.coverage.Specialist Visit (Out-of-Network)",
      },
      {
        label: "Urgent Care Visit (In-Network)",
        path: "details.coverage.Urgent Care Visit (In-Network)",
      },
    ],
  },
  {
    title: "Hospital & Emergency",
    items: [
      {
        label: "Inpatient Hospital Stay",
        path: "details.coverage.Inpatient Hospital Stay",
      },
      {
        label: "Emergency Room Visit",
        path: "details.coverage.Emergency Room Visit",
      },
      {
        label: "Emergency Medical Transportation",
        path: "details.coverage.Emergency Medical Transportation",
      },
    ],
  },
  {
    title: "Diagnostic Services",
    items: [
      {
        label: "Diagnostic Tests (lab, blood work)",
        path: "details.coverage.Diagnostic Tests (lab, blood work)",
      },
      {
        label: "Imaging (CT scans, PET scans, MRIs)",
        path: "details.coverage.Imaging (CT scans, PET scans, MRIs)",
      },
    ],
  },
  {
    title: "Prescription Drugs",
    items: [
      {
        label: "Drug Deductible",
        path: "details.coverage.Drug Deductible",
      },
      {
        label: "Generic Drugs (In-Network Pharmacy)",
        path: "details.coverage.Generic Drugs (In-Network Pharmacy)",
      },
      {
        label: "Preferred Brand Drugs (In-Network Pharmacy)",
        path: "details.coverage.Preferred Brand Drugs (In-Network Pharmacy)",
      },
      {
        label: "Non-Preferred Brand Drugs (In-Network Pharmacy)",
        path: "details.coverage.Non-Preferred Brand Drugs (In-Network Pharmacy)",
      },
      {
        label: "Specialty Drugs",
        path: "details.coverage.Specialty Drugs",
      },
      {
        label: "Rx Costs",
        path: "details.coverage.Rx Costs",
      },
    ],
  },
];

// Dental Plan Field Groups
export const DENTAL_FIELD_GROUPS: ObjectPathFieldGroup[] = [
  {
    title: "Basic Plan Costs",
    items: [
      {
        label: "Reimbursement - In-Network",
        path: "details.coverage.Reimbursement (how much the insurance company pays thef or care) - In-Network",
      },
      {
        label: "Reimbursement - Out-of-Network",
        path: "details.coverage.Reimbursement (how much the insurance company pays thef or care) - Out-of-Network",
      },
      {
        label: "Coinsurance - In-Network",
        path: "details.coverage.Coinsurance - In-Network",
      },
      {
        label: "Coinsurance - Out-of-Network",
        path: "details.coverage.Coinsurance - Out-of-Network",
      },
      {
        label: "Annual Deductible - In-Network",
        path: "details.coverage.Annual Individual / Family Deductible - In-Network",
      },
      {
        label: "Annual Deductible - Out-of-Network",
        path: "details.coverage.Annual Individual / Family Deductible - Out-of-Network",
      },
      {
        label: "Annual Max Benefit - In-Network",
        path: "details.coverage.Annual Individual Maxium Benefit - In-Network",
      },
      {
        label: "Annual Max Benefit - Out-of-Network",
        path: "details.coverage.Annual Individual Maxium Benefit - Out-of-Network",
      },
    ],
  },
  {
    title: "Procedures",
    items: [
      {
        label: "Routine dental checkup (In-Network)",
        path: "details.priocedures.Routine dental checkup (In-Network)",
      },
      {
        label: "Routine dental checkup (Out-of-Network)",
        path: "details.priocedures.Routine dental checkup (Out-of-Network)",
      },
      {
        label: "Full mouth X-rays (In-Network)",
        path: "details.priocedures.Full mouth X-rays (In-Network)",
      },
      {
        label: "Full mouth X-rays (Out-of-Network)",
        path: "details.priocedures.Full mouth X-rays (Out-of-Network)",
      },
      {
        label: "Emergency pain relief/treatment (In-Network)",
        path: "details.priocedures.Emergency pain relief/treatment (In-Network)",
      },
      {
        label: "Emergency pain relief/treatment (Out-of-Network)",
        path: "details.priocedures.Emergency pain relief/treatment (Out-of-Network)",
      },
      {
        label: "Fillings (In-Network)",
        path: "details.priocedures.Fillings (In-Network)",
      },
      {
        label: "Fillings (Out-of-Network)",
        path: "details.priocedures.Fillings (Out-of-Network)",
      },
      {
        label: "Basic tooth removal (In-Network)",
        path: "details.priocedures.Basic tooth removal (In-Network)",
      },
      {
        label: "Basic tooth removal (Out-of-Network)",
        path: "details.priocedures.Basic tooth removal (Out-of-Network)",
      },
      {
        label: "Gum cleaning (In-Network)",
        path: "details.priocedures.Gum cleaning (In-Network)",
      },
      {
        label: "Surgical tooth removal (In-Network)",
        path: "details.priocedures.Surgical tooth removal (In-Network)",
      },
      {
        label: "Surgical tooth removal (Out-of-Network)",
        path: "details.priocedures.Surgical tooth removal (Out-of-Network)",
      },
      {
        label: "Root canals (In-Network)",
        path: "details.priocedures.Root canals (In-Network)",
      },
      {
        label: "Root canals (Out-of-Network)",
        path: "details.priocedures.Root canals (Out-of-Network)",
      },
      {
        label: "Tooth caps and covers (In-Network)",
        path: "details.priocedures.Tooth caps and covers (In-Network)",
      },
      {
        label: "Tooth replacements (In-Network)",
        path: "details.priocedures.Tooth replacements (In-Network)",
      },
      {
        label: "Tooth replacements (Out-of-Network)",
        path: "details.priocedures.Tooth replacements (Out-of-Network)",
      },
    ],
  },
];

// Vision Plan Field Groups
export const VISION_FIELD_GROUPS: ObjectPathFieldGroup[] = [
  {
    title: "Coverage Details",
    items: [
      {
        label: "Exams Copay",
        path: "details.coverage.Exams Copay",
      },
      {
        label: "Materials Copay (waived for contact lenses)",
        path: "details.coverage.Materials Copay (waived for contact lenses)",
      },
      {
        label: "Eye Exam Coverage - In-Network",
        path: "details.coverage.Eye Exam Covereage - In-Network",
      },
      {
        label: "Eye Exam Coverage - Out-of-Network",
        path: "details.coverage.Eye Exam Covereage - Out-of-Network",
      },
      {
        label: "Single Vision Lenses - In-Network",
        path: "details.coverage.Single Vision Lenses - In-Network",
      },
      {
        label: "Single Vision Lenses - Out-of-Network",
        path: "details.coverage.Single Vision Lenses - Out-of-Network",
      },
      {
        label: "Lined Bifocal Lenses - In-Network",
        path: "details.coverage.Lined Bifocal Lenses - In-Network",
      },
      {
        label: "Lined Bifocal Lenses - Out-of-Network",
        path: "details.coverage.Lined Bifocal Lenses - Out-of-Network",
      },
      {
        label: "Lined Trifocal Lenses - In-Network",
        path: "details.coverage.Lined Trifocal Lenses - In-Network",
      },
      {
        label: "Lined Trifocal Lenses - Out-of-Network",
        path: "details.coverage.Lined Trifocal Lenses - Out-of-Network",
      },
      {
        label: "Lenticular - In-Network",
        path: "details.coverage.Lenticular - In-Network",
      },
      {
        label: "Lenticular - Out-of-Network",
        path: "details.coverage.Lenticular - Out-of-Network",
      },
      {
        label: "Frames - In-Network",
        path: "details.coverage.Frames - In-Network",
      },
      {
        label: "Frames - Out-of-Network",
        path: "details.coverage.Frames - Out-of-Network",
      },
      {
        label: "Costco, Walmart, and Sam's Club Frame Allowance - In-Network",
        path: "details.coverage.Costco, Walmart, and Sam's Club Frame Allowance - In-Network",
      },
      {
        label: "Contact Lenses (elective) - In-Network",
        path: "details.coverage.Contact Lense (elective) - In-Network",
      },
      {
        label: "Contact Lenses (elective) - Out-of-Network",
        path: "details.coverage.Contact Lenses (elective) - Out-of-Network",
      },
      {
        label: "Contact Lenses (medically necessary) - In-Network",
        path: "details.coverage.Contact Lenses (medically necessary) - In-Network",
      },
      {
        label: "Contact Lenses (medically necessary) - Out-of-Network",
        path: "details.coverage.Contact Lenses (medically necessary) - Out-of-Network",
      },
      {
        label: "Contact Lenses (evaluation and fitting) - In-Network",
        path: "details.coverage.Contact Lenses (evaluation and fitting) - In-Network",
      },
      {
        label: "Contact Lenses (evaluation and fitting) - Out-of-Network",
        path: "details.coverage.Contact Lenses (evaluation and fitting) - Out-of-Network",
      },
      {
        label: "Laser Correction Surgery Discount - In-Network",
        path: "details.coverage.Laser Correction Surgery Discount - In-Network",
      },
      {
        label: "Laser Correction Surgery Discount - Out-of-Network",
        path: "details.coverage.Laser Correction Surgery Discount - Out-of-Network",
      },
    ],
  },
  {
    title: "Service Frequencies",
    items: [
      {
        label: "Exams",
        path: "details.serviceFrequencies.Exams",
      },
      {
        label: "Lenses (for glasses or contact lenses)",
        path: "details.serviceFrequencies.Lenses (for glasses or contact lenses)***",
      },
      {
        label: "Frames",
        path: "details.serviceFrequencies.Frames",
      },
      {
        label: "Network Discounts",
        path: "details.serviceFrequencies.Network Discounts (glasses and contact lens professional service)",
      },
    ],
  },
];

// Accident Plan Field Groups (extracted from Simplified_Accident_Plan_Comparison_V2_2025.csv)
export const ACCIDENT_FIELD_GROUPS: ObjectPathFieldGroup[] = [
  {
    title: "Coverage Basics",
    items: [
      {
        label: "Accidental Death",
        path: "details.lifeAndDismembermentLosses.Accidental Death - Employee/Spouse/Child",
      },
      {
        label: "Accidental Death - Travel",
        path: "details.lifeAndDismembermentLosses.Accidental Death - Travel: If you die in an accident on a bus, train, plane, or similar, the insurance pays extra. Employee/Spouse/Child",
      },
    ],
  },
  {
    title: "Accidental Dismemberment (partial list)",
    items: [
      {
        label: "Loss of one hand, foot, leg, or arm",
        path: "details.accidentalDismemberment.Loss of one hand, foot, leg, or arm - Employee/Spouse/Child",
      },
      {
        label: "Loss of one finger or toe",
        path: "details.accidentalDismemberment.Loss of one finger or toe - Employee/Spouse/Child",
      },
      {
        label: "Loss of two or more fingers or toes",
        path: "details.accidentalDismemberment.Loss of two or more fingers or toes - Employee/Spouse/Child",
      },
      {
        label: "Loss of hearing or loss of an ear (one ear)",
        path: "details.accidentalDismemberment.Loss of hearing or loss of an ear (one ear) - Employee/Spouse/Child",
      },
      {
        label: "Loss of sight or loss of an eye (one eye)",
        path: "details.accidentalDismemberment.Loss of sight or loss of an eye (one eye) - Employee/Spouse/Child",
      },
    ],
  },
  {
    title: "Dislocations (partial list)",
    items: [
      {
        label: "Hip",
        path: "details.dislocations.Hip (surgery required /no surgery required)",
      },
      {
        label: "Knee, ankle or bones of the foot",
        path: "details.dislocations.Knee, ankle or bones of the foot (surgery required /no surgery required)",
      },
      {
        label: "Shoulder",
        path: "details.dislocations.Shoulder (surgery required /no surgery required)",
      },
      {
        label: "Elbow or wrist",
        path: "details.dislocations.Elbow or wrist (surgery required /no surgery required)",
      },
      {
        label: "Finger(s) or toe(s)",
        path: "details.dislocations.Finger(s) or toe(s) (surgery required /no surgery required)",
      },
      {
        label: "Lower Jaw",
        path: "details.dislocations.Lower Jaw (surgery required /no surgery required)",
      },
      {
        label: "Incomplete dislocation",
        path: "details.dislocations.Incomplete dislocation (surgery required /no surgery required)",
      },
    ],
  },
  {
    title: "Fractures (partial list)",
    items: [
      {
        label: "Hip or thigh",
        path: "details.fractures.Hip or thigh (surgery required/no surgery required) ",
      },
      {
        label: "Cracked or crushed skull (serious head injury)",
        path: "details.fractures.Cracked or crushed skull - serious head injury (surgery required /no surgery required)",
      },
      {
        label: "Cracked or crushed skull (simple injury)",
        path: "details.fractures.Cracked or crushed skull - simple injury (surgery required /no surgery required)",
      },
      {
        label: "Leg (tibia or fibula)",
        path: "details.fractures.Leg - tibia or fiblua (surgery required /no surgery required)",
      },
      {
        label: "Pelvis (excluding coccyx)",
        path: "details.fractures.Pelvis - excluding coccyx (surgery required /no surgery required)",
      },
      {
        label: "Vertebrae or sternum",
        path: "details.fractures.Vertebrae or sternum (surgery required /no surgery required)",
      },
      {
        label: "Upper jaw or upper arm",
        path: "details.fractures.Upper jaw or upper arm (surgery required /no surgery required)",
      },
      {
        label: "Lower jaw",
        path: "details.fractures.Lower jaw (surgery required /no surgery required)",
      },
      {
        label: "Knee cap, ankle, foot, collarbone, shoulder, forearm, hand, wrist, elbow, heel",
        path: "details.fractures.Knee cap, ankle, foot, collarbone, shoulder, forearm, hand, wrist, elbow, heel (surgery required /no surgery required)",
      },
      {
        label: "Rib, finger, toe or coccyx",
        path: "details.fractures.Rib, finger, toe or coccyx (surgery required /no surgery required)",
      },
      {
        label: "Multiple ribs",
        path: "details.fractures.Multiple ribs (surgery required /no surgery required)",
      },
      {
        label: "Chip fractures or fractures not requiring surgery",
        path: "details.fractures.Chip fractures or fractures not requiring surgery",
      },
    ],
  },
  {
    title: "Additional Injuries",
    items: [
      {
        label: "Eye injury",
        path: "details.additionalInjuries.Eye injury",
      },
      {
        label: "Gunshot wound",
        path: "details.additionalInjuries.Gunshot wound",
      },
      {
        label: "Brain injury",
        path: "details.additionalInjuries.Brain injury",
      },
      {
        label: "Paralysis (monoplegia)",
        path: "details.additionalInjuries.Paralysis (monoplegia)",
      },
      {
        label: "Paralysis (diplegia)",
        path: "details.additionalInjuries.Paralysis (diplegia)",
      },
      {
        label: "Paralysis (hemiplegia)",
        path: "details.additionalInjuries.Paralysis (hemiplegia)",
      },
      {
        label: "Paralysis (paraplegia)",
        path: "details.additionalInjuries.Paralysis (paraplegia)",
      },
      {
        label: "Paralysis (quadriplegia)",
        path: "details.additionalInjuries.Paralysis (quadriplegia)",
      },
      {
        label: "Coma",
        path: "details.additionalInjuries.Coma",
      },
      {
        label: "Concussion",
        path: "details.additionalInjuries.Concussion",
      },
      {
        label: "Concussion lifetime maximum benefit",
        path: "details.additionalInjuries.Concussion lifetime maximum benefit",
      },
    ],
  },
  {
    title: "Lacerations",
    items: [
      {
        label: "Laceration(s) with no sutures",
        path: "details.lacerations.Laceration(s) with no sutures and treated by a physician",
      },
      {
        label: "Single laceration under 5 cm with suture",
        path: "details.lacerations.Single laceration under 5 cm with suture",
      },
      {
        label: "Lacerations 5-15 cm with sutures",
        path: "details.lacerations.Lacerations 5-15 cm with sutures (total of all lacerations)",
      },
      {
        label: "Lacerations greater than 15 cm with sutures",
        path: "details.lacerations.Lacerations greater than 15 cm with sutures (total of all lacerations)",
      },
    ],
  },
  {
    title: "Surgery (partial list)",
    items: [
      {
        label: "Misc surgery requiring general anesthesia",
        path: "details.surgery.Misc surgery requiring general anesthesia",
      },
      {
        label: "Open surgery",
        path: "details.surgery.Open surgery",
      },
      {
        label: "Exploratory surgery or debridement",
        path: "details.surgery.Exploratory surgery or debridement",
      },
      {
        label: "Laparoscopic surgery or hernia repair",
        path: "details.surgery.Laparoscopic surgery or hernia repair",
      },
      {
        label: "Tendon/Ligament/Rotator cuff tear",
        path: "details.surgery.Tendon/Ligament/Rotator cuff tear",
      },
      {
        label: "Torn knee cartilage",
        path: "details.surgery.Torn knee cartilage",
      },
      {
        label: "Ruptured/herniated disc",
        path: "details.surgery.Ruptured/herniated disc",
      },
    ],
  },
  {
    title: "Burns",
    items: [
      {
        label: "21-40 sq. cm second degree",
        path: "details.burns.21-40 sq. cm second degree",
      },
      {
        label: "21-40 sq. cm third degree",
        path: "details.burns.21-40 sq. cm third degree",
      },
      {
        label: "41-65 sq. cm second degree",
        path: "details.burns.41-65 sq. cm second degree",
      },
      {
        label: "41-65 sq. cm third degree",
        path: "details.burns.41-65 sq. cm third degree",
      },
      {
        label: "66-160 sq. cm second degree",
        path: "details.burns.66-160 sq. cm second degree",
      },
      {
        label: "66-160 sq. cm third degree",
        path: "details.burns.66-160 sq. cm third degree",
      },
      {
        label: "161-225 sq. cm second degree",
        path: "details.burns.161-225 sq. cm second degree",
      },
      {
        label: "161-225 sq. cm third degree",
        path: "details.burns.161-225 sq. cm third degree",
      },
      {
        label: "More than 225 sq. cm second degree",
        path: "details.burns.More than 225 sq. cm second degree",
      },
      {
        label: "More than 225 sq. cm third degree",
        path: "details.burns.More than 225 sq. cm third degree",
      },
      {
        label: "Skin graft",
        path: "details.burns.Skin graft",
      },
    ],
  },
  {
    title: "Medical Services (partial list)",
    items: [
      {
        label: "Diagnostic exam (MRI, CT, etc.)",
        path: "details.medicalServices.Diagnostic exam (MRI, CT, etc.)",
      },
      {
        label: "X-ray (per accident)",
        path: "details.medicalServices.X-ray (per accident)",
      },
      {
        label: "Accident emergency treatment (non-ER)",
        path: "details.medicalServices.Accident emergency treatment (non-ER)",
      },
      {
        label: "Follow-up physician visit",
        path: "details.medicalServices.Follow-up physician visit",
      },
      {
        label: "Physical or occupational therapy",
        path: "details.medicalServices.Physical or occupational therapy",
      },
      {
        label: "Medical devices",
        path: "details.medicalServices.Medical devices",
      },
      {
        label: "Epidural pain management",
        path: "details.medicalServices.Epidural pain management",
      },
      {
        label: "Prescription drug",
        path: "details.medicalServices.Prescription drug",
      },
      {
        label: "Prosthesis (one)",
        path: "details.medicalServices.Prosthesis (one)",
      },
      {
        label: "Prosthesis (two)",
        path: "details.medicalServices.Prosthesis (two)",
      },
      {
        label: "Anesthesia",
        path: "details.medicalServices.Anesthesia",
      },
      {
        label: "Blood / plasma transfusion",
        path: "details.medicalServices.Blood / plasma transfusion",
      },
    ],
  },
  {
    title: "Hospital",
    items: [
      {
        label: "Hospital admission",
        path: "details.hospital.Hospital admission",
      },
      {
        label: "Hospital confinement",
        path: "details.hospital.Hospital confinement",
      },
      {
        label: "ICU admission",
        path: "details.hospital.ICU admission",
      },
      {
        label: "ICU confinement",
        path: "details.hospital.ICU confinement",
      },
      {
        label: "Ground ambulance",
        path: "details.hospital.Ground ambulance",
      },
      {
        label: "Air ambulance",
        path: "details.hospital.Air ambulance",
      },
      {
        label: "ER admission or urgent care",
        path: "details.hospital.ER admission or urgent care",
      },
    ],
  },
  {
    title: "Emergency Dental",
    items: [
      {
        label: "Emergency dental extraction",
        path: "details.emergencyDental.Emergency dental extraction",
      },
      {
        label: "Emergency dental crown",
        path: "details.emergencyDental.Emergency dental crown",
      },
    ],
  },
  {
    title: "Wellness & Additional Benefits",
    items: [
      {
        label: "Wellness screening benefit",
        path: "details.wellnessBenefit.Wellness screening benefit",
      },
      {
        label: "Family lodging",
        path: "details.additionalBenefit.Family lodging",
      },
      {
        label: "Transportation (100+ miles)",
        path: "details.additionalBenefit.Transportation (100+ miles)",
      },
      {
        label: "Rehabilitation unit",
        path: "details.additionalBenefit.Rehabilitation unit",
      },
    ],
  },
];

// Critical Illness Plan Field Groups
export const CRITICAL_ILLNESS_FIELD_GROUPS: ObjectPathFieldGroup[] = [
  {
    title: "Covered Conditions",
    items: [
      {
        label: "Heart Attack",
        path: "details.coverage.Heart Attack - Benefit Percentages",
      },
      {
        label: "Stroke",
        path: "details.coverage.Stroke",
      },
      {
        label: "Major organ failure",
        path: "details.coverage.Major organ failure",
      },
      {
        label: "End-stage heart failure",
        path: "details.coverage.End-stage heart failure",
      },
      {
        label: "End-stage kidney disease",
        path: "details.coverage.End-stage kidney disease",
      },
      {
        label: "Occupational infectious disease",
        path: "details.coverage.Occupational infectious disease",
      },
      {
        label: "Coronary Artery Bypass",
        path: "details.coverage.Coronary Artery Bypass",
      },
      {
        label: "Angioplasty",
        path: "details.coverage.Angioplasty",
      },
      {
        label: "Invasive Cancer",
        path: "details.coverage.Invasive Cancer",
      },
      {
        label: "Early-stage cancer that hasn't spread",
        path: "details.coverage.Cancer in Situ (early-stage cancer that hasn't spread)",
      },
      {
        label: "Skin Cancer",
        path: "details.coverage.Skin Cancer",
      },
      {
        label: "Benign Brain Tumor",
        path: "details.coverage.Benign Brain Tumor",
      },
      {
        label: "Coma",
        path: "details.coverage.Coma",
      },
      {
        label: "Paralysis",
        path: "details.coverage.Paralysis",
      },
      {
        label: "Severe Burns",
        path: "details.coverage.Severe Burns",
      },
      {
        label: "Advanced ALS (Lou Gehrig's Disease)",
        path: "details.coverage.Advanced ALS (Lou Gehrig\u2019s Disease)",
      },
      {
        label: "Advanced Alzheimer's Disease",
        path: "details.coverage.Advanced Alzheimer's Disease",
      },
      {
        label: "Advanced Parkinson's Disease",
        path: "details.coverage.Advanced Parkinson's Disease",
      },
      {
        label: "Blindness",
        path: "details.coverage.Blindness",
      },
      {
        label: "Complete Loss of Hearing",
        path: "details.coverage.Complete Loss of Hearing",
      },
      {
        label: "Loss of Speech",
        path: "details.coverage.Loss of Speech",
      },
    ],
  },
  {
    title: "Childhood Specific Diseases (partial list)",
    items: [
      {
        label: "Cerebral Palsy",
        path: "details.childhoodSpecificDiseases.Cerebral Palsy",
      },
      {
        label: "Complex Congenital Heart Disease",
        path: "details.childhoodSpecificDiseases.Complex Congenital Heart Disease",
      },
      {
        label: "Cystic Fibrosis",
        path: "details.childhoodSpecificDiseases.Cystic Fibrosis",
      },
      {
        label: "Type 1 Diabetes",
        path: "details.childhoodSpecificDiseases.Type 1 Diabetes Mellitus",
      },
      {
        label: "Muscular Dystrophy",
        path: "details.childhoodSpecificDiseases.Muscular Dystrophy - Benefit Percentages",
      },
      {
        label: "Down Syndrome",
        path: "details.childhoodSpecificDiseases.Down Syndrome",
      },
      {
        label: "Spina Bifida",
        path: "details.childhoodSpecificDiseases.Spina Bifida",
      },
      {
        label: "Cleft Lip/Palate",
        path: "details.childhoodSpecificDiseases.Cleft Lip/Palate",
      },
    ],
  },
];

// Hospital Plan Field Groups
export const HOSPITAL_FIELD_GROUPS: ObjectPathFieldGroup[] = [
  {
    title: "Included benefits",
    items: [
      {
        label: "First Day Hospital",
        path: "details.benefits.First Day Hospital - Pays for your first day in the hospital",
      },
      {
        label: "First Day ICU Stay",
        path: "details.benefits.First Day ICU Stay - Pays extra for your first day in intensive care",
      },
      {
        label: "Daily Hospital Stay",
        path: "details.benefits.Daily Hospital Stay - Pays for each full day you're in the hospital",
      },
      {
        label: "Daily ICU Stay",
        path: "details.benefits.Daily ICU Stay - Pays more for each day in intensive care",
      },
      {
        label: "Daily Rehab Stay",
        path: "details.benefits.Daily Rehab Stay - Pays for each day in a rehab unit",
      },
      {
        label: "Yearly Wellness Visit",
        path: "details.benefits.Yearly Wellness Visit - Pays for your annual checkup or screening",
      },
      {
        label: "Emergency Room (Accident Only)",
        path: "details.benefits.Emergency Room (Accident Only) - Pays if you go to the ER after an accident",
      },
      {
        label: "Daily Family Care",
        path: "details.benefits.Daily Family Care - Pays for help taking care of your family while you're hospitalized",
      },
      {
        label: "Daily Lodging",
        path: "details.benefits.Daily Lodging - Pays for a hotel if a loved one travels to be near you",
      },
      {
        label: "Daily Travel",
        path: "details.benefits.Daily Travel - Pays for your transportation to get care",
      },
    ],
  },
];

// Master mapping of all field groups by category
export const CATEGORY_FIELD_GROUPS: Record<string, ObjectPathFieldGroup[]> = {
  'Major Medical': MEDICAL_FIELD_GROUPS,
  'Dental': DENTAL_FIELD_GROUPS,
  'Vision': VISION_FIELD_GROUPS,
  'Accident': ACCIDENT_FIELD_GROUPS,
  'Critical Illness': CRITICAL_ILLNESS_FIELD_GROUPS,
  'Hospital Indemnity': HOSPITAL_FIELD_GROUPS,
};